import { render, staticRenderFns } from "./IconTypeformLongText.vue?vue&type=template&id=14638944&"
import script from "./IconTypeformLongText.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformLongText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports